<template>
  <div v-if="isShowModal" class="prod-modal__wrapper">
    <div class="prod-modal">
      <div class="prod-modal__header">
        תצוגה מקדימה
        <div class="prod-modal__close" @click="isShowModal = false">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.9375 10.0002L19.7943 2.21235C20.3056 1.70578 20.3056 0.886736 19.7943 0.380169C19.2833 -0.126398 18.4569 -0.126398 17.9459 0.380169L10.0888 8.16801L2.23195 0.380169C1.72064 -0.126398 0.894552 -0.126398 0.383482 0.380169C-0.127827 0.886736 -0.127827 1.70578 0.383482 2.21235L8.24031 10.0002L0.383482 17.788C-0.127827 18.2946 -0.127827 19.1137 0.383482 19.6202C0.638179 19.8729 0.973067 19.9998 1.30772 19.9998C1.64237 19.9998 1.97701 19.8729 2.23195 19.6202L10.0888 11.8324L17.9459 19.6202C18.2008 19.8729 18.5354 19.9998 18.8701 19.9998C19.2047 19.9998 19.5394 19.8729 19.7943 19.6202C20.3056 19.1137 20.3056 18.2946 19.7943 17.788L11.9375 10.0002Z"
              fill="#00000F"/>
          </svg>
        </div>
      </div>
      <div class="prod-modal__body">
        <div class="prod__title">
          {{ product.name }}
        </div>
        <product-modal-images :product="product" :color_id="colorId"/>
        <product-options :product-options="productOptions" :color_id="colorId" @selected="onVariantSelected"/>

        <div class="prod__price">
          <div class="prod__price__title">
            מחיר:
          </div>
          <div class="prod__price__current" id="price">₪{{ product.price }}</div>
          <div class="prod__price__old">
            {{ product.price !== product.old_price ? `₪${product.old_price}` : '' }}
          </div>
        </div>

        <div class="prod__button" @click="onConfirm">
          הוסף לסל
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductModalImages from "./product-modal-images";
import ProductOptions from "./product-options";
import {computed, ref} from "vue";

export default {
  name: "ProductModal",
  components: {
    ProductOptions,
    ProductModalImages,
  },
  mounted() {
    window.addEventListener('keyup', ev => {
      if (ev.keyCode === 27) {
        this.isShowModal = false
      }
    });
  },
  setup(props, {emit}) {
    const colorId = ref(0)
    const isShowModal = ref(false)
    const product = ref(null)
    const productOptions = ref(null)

    const selectedVariant = ref(null);
    const onVariantSelected = (data) => {
      selectedVariant.value = data
    }

    const onConfirm = () => {
      let vars = [];
      if (Array.isArray(product.value.options.variants)) {
        vars = product.value.options.variants
      } else {
        vars = Object.values(product.value.options.variants)
      }
      if (vars.length && !selectedVariant.value) {
        /*const po = document.querySelector('.prod-modal .product__options')
        if (po) {
          po.style.color = 'red'
          setTimeout(function () {
            po.style.color = 'inherit'
          }, 2000);
        }*/
        for (var key in window.product.selected)
        {
          if(!window.product.selected[key]) {
            $("#" + key).css('color', 'red');
          }
        }
        setTimeout(function () {
          for(var key in window.product.selected) {
            $("#" + key).css('color', 'inherit');
          }
        }, 2000);
        return;
      }
      let rangeVal = null;
      const range = document.getElementsByClassName('slider-tooltip-top');
      if(range.length) {
        rangeVal = range[0].textContent;
      }
      const data = {
        product_id: product.value.id,
        name: product.value.name,
        data: {...selectedVariant.value},
        category: product.value?.category ?? '',
        price: product.value?.total_price ?? product.value.price,
        article: product.value.article,
        strings: rangeVal,
      }
      emit('selected', data)
      window.dispatchEvent(new CustomEvent('productSelectedConfirm', {
        detail: data
      }))

      if (document.getElementById('header-cart')) {
        let cart = $('#header-cart');
        let imgtodrag = $('.prod-modal__wrapper').find('img').eq(0);
        if (!imgtodrag.length) {
          imgtodrag = $(`.product__item[data-pid="${data.product_id}"]`).find('img').eq(0);
        }
        if (imgtodrag.length) {
          let imgclone = imgtodrag.clone()
            .offset({top: imgtodrag[0].getBoundingClientRect().top, left: imgtodrag[0].getBoundingClientRect().left})
            .css({
              'opacity': '0.5',
              'position': 'fixed',
              'height': '150px',
              'width': '150px',
              'z-index': '100'
            })
            .appendTo($('body'))
            .animate({
              'top': 10,
              'left': cart.offset().left + 10,
              'width': 75,
              'height': 75
            }, 1000);
          imgclone.animate({
            'width': 0,
            'height': 0
          }, function () {
            imgclone.remove()
          });
        }

        $(".success-card-info").css("display", "flex");
        setTimeout(function () {
          $(".success-card-info").css("display", "none");
        }, 1500);
      }
      console.log(111)

      isShowModal.value = false
      window.product = null;
    }

    const show = (product_id) => {
      selectedVariant.value = null
      window.selectedVariant = null

      axios
        .get(route('client.product.modal', {product: product_id}))
        .then((resp) => {

          colorId.value = resp.data.product.color_id
          product.value = resp.data.product
          productOptions.value = resp.data.product.options
          window.product = product.value;
          const vals = Object.values(resp.data.product.options.variants)
          if (vals.length === 1) {
            const variant = vals[0]
            const options = resp.data.product.options

            const valOpts = (options?.options || []).flatMap(o => o.values.map(v => {
              return {
                val_id: v.id,
                opt: o,
              }
            })).reduce((a, i) => {
              a[i.val_id] = i.opt;
              return a
            }, {})

            const opts = Object.values(variant.attr_values).map(i => {
              if (i && valOpts[i].option_type === 'opt') {
                return {
                  opt_id: valOpts[i].id.toString().replace(/\D/g, ''),
                  val_id: i.toString().replace(/\D/g, ''),
                }
              }
            }).filter(i => i)

            const data = {
              variant: variant,
              options: opts
            };

            onVariantSelected(data)
            onConfirm()
          } else if (vals.length === 0) {
            onConfirm()
          } else {
            isShowModal.value = true
          }
        }).catch(e => {
      })
    }

    return {colorId, isShowModal, product, productOptions, selectedVariant, onVariantSelected, onConfirm, show}
  },
}
</script>

<style lang="scss">
@import '../../../client/scss/_mixins.scss';
#pam {
  .range-container {
    width: 285px;
  }
}
.prod-modal {
  @include bp(phone) {
    width: 100%;
  }
  @media screen and (min-width: 1925px) {
    width: 540px;
  }

  &__wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 40;
  }

  overflow-y: auto;
  overflow-x: hidden;
  width: 454px;
  background: #FFFFFF;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 29;
  padding: 25px;
  box-shadow: 10px 0px 10px 1px rgb(0 0 0 / 31%);

  &__close {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  &__header {
    font-size: 24px;
    line-height: 1;
    font-weight: 700;
    padding-bottom: 25px;
    border-bottom: solid 1px #E5E5E5;
    display: flex;
    justify-content: space-between;
  }

  &__body {
    padding-top: 30px;
  }
}
.product__option__title {
  margin-left: 10px;
}

.prod {
  &__title {
    font-size: 23px;
    text-transform: uppercase;
  }

  &__price {
    display: flex;
    margin-top: cvw(40px);
    @include bp(mini) {
      margin-top: cvm(40px);
    }

    &__title {
      display: flex;
      min-width: cvw(100px);
      @include bp(phone) {
        min-width: cvm(155px);
      }
      @include bp(mini) {
        min-width: cvm(100px);
      }
    }

    &__current {
      font-size: 24px;
      font-weight: bold;
      margin-inline-end: cvw(15px);
    }

    &__old {
      font-size: 18px;
      font-weight: normal;
      text-decoration: line-through;
      color: #888888;
    }
  }

  &__slider {
    height: 404px;
    @media (max-width: 400px) {
      height: fit-content;
    }

    img {
      width: 100%;
      height: auto;
    }

    .swiper-button-next,
    .swiper-button-prev {
      &:after {
        content: none;
      }
    }

    .swiper-button {
      &-next {
        background: url("/client/img/product/sarrow-right.svg") center no-repeat;
        background-size: contain;
        width: 20px;
        right: 0px;
      }

      &-prev {
        background: url("/client/img/product/sarrow-left.svg") center no-repeat;
        left: 0px;
        right: unset;
      }
    }
  }

  &__gallery {
    height: 70px;

    @media (max-width: 400px) {
      margin-top: 30px;
      height: fit-content;
    }

    img {
      cursor: pointer;
      width: 100%;
      height: auto;
    }

    .swiper-slide {
      display: inline-block;
      border: solid 1px #F2F2F2;

      &-thumb-active {
        &:after {
          content: '';
          display: block;
          background: #019CDE;
          height: 2px;
          width: 100%;
          position: absolute;
          bottom: -2px;
        }
      }
    }
  }

  &__button {
    height: 66px;
    width: 100%;
    font-size: 18px;
    color: #fff;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    cursor: pointer;
  }
}
</style>
